import { logger } from '../../logger'

const getImageResolution = (
  file: File,
): Promise<{ width: number; height: number } | null> =>
  new Promise((resolve) => {
    const img = new Image()
    const objectUrl = URL.createObjectURL(file)

    img.onload = () => {
      resolve({ width: img.naturalWidth, height: img.naturalHeight })
      URL.revokeObjectURL(objectUrl)
    }
    img.onerror = (e) => {
      console.log(111, 'Failed to load image', e as string)
      logger.warn('Failed to load image')
      resolve(null)
      URL.revokeObjectURL(objectUrl)
    }

    img.src = objectUrl
  })

export default getImageResolution
